import React from 'react';
import { cn } from '../../design-system/cn';
import { semanticColors, domainColors, typography, radii } from '../../design-system/tokens';
import { statusColors } from '../../design-system/tokens/status';

const { accent, warning } = semanticColors;

const VARIANTS = {
  brand: `${accent.surfaceEmphasis} ${accent.textEmphasis} ${accent.borderEmphasis}`,
  /** High-contrast solid LIVE pill */
  liveSolid: `${accent.bg} ${accent.onAccent} ${accent.borderSolid}`,
  /** Soft live status — matches LiveGamePeriodBadge palette */
  live: `${statusColors.live.surface} ${statusColors.live.text} ${statusColors.live.border}`,
  wallet: `${domainColors.wallet.surface} ${domainColors.wallet.text} ${domainColors.wallet.borderEmphasis}`,
  admin: `${domainColors.admin.surfaceEmphasis} ${domainColors.admin.textEmphasis} ${domainColors.admin.borderEmphasis}`,
  warning: `${warning.surfaceEmphasis} ${warning.text} ${warning.borderEmphasis}`,
  neutral: `${domainColors.neutral.surface} ${domainColors.neutral.textMuted} ${domainColors.neutral.border}`,
  unread: `${accent.bg} ${accent.onAccent} ${accent.borderSolid}`,
  upcoming: `${statusColors.upcoming.surface} ${statusColors.upcoming.text} ${statusColors.upcoming.border}`,
  final: `${statusColors.final.surface} ${statusColors.final.text} ${statusColors.final.border}`,
};

export default function Badge({ variant = 'neutral', className, children }) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-1 border',
        radii.pill,
        typography.micro,
        VARIANTS[variant] || VARIANTS.neutral,
        className
      )}
    >
      {children}
    </span>
  );
}
